import client from './client';
import { unwrapData } from './response';

export const listServices = async (params = {}) => {
  const response = await client.get('/services', { params });
  return unwrapData(response);
};

export const createService = async (payload) => {
  const response = await client.post('/services', payload);
  return unwrapData(response, null);
};

export const updateService = async (id, payload) => {
  const response = await client.patch(`/services/${id}`, payload);
  return unwrapData(response, null);
};

export const deleteService = async (id) => {
  const response = await client.delete(`/services/${id}`);
  return unwrapData(response, null);
};
